import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import {Select} from 'components/forms';

const getHourOptions = () => {
    const hours = [];
    for (let i = 6; i < 22; i++) {
        const h = i < 10 ? `0${i}` : i;
        hours.push({label: `${h}:00 hs`, value: `${h}:00:00`}, {label: `${h}:30 hs`, value: `${h}:30:00`});
    }
    return hours;
};

@autobind
export default class TimeInput extends Component {
    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
    }

    handleChange(value) {
        this.props.onChange(value);
    }

    render() {
        return (
            <Select
                theme='outline'
                value={this.props.value}
                options={getHourOptions()}
                placeholder='Seleccioná una hora'
                onChange={this.handleChange}
                onBlur={this.props.onBlur}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/time-input/index.js